export default {
  data() {
    return {};
  },
  computed: {
    role() {
      return this.$store.getters.roles;
    }
  },
  methods: {
    handleChangeRole(e) {
      const role = e.target.value;
      this.$store.dispatch('permission/changeRole', role);
    }
  }
};